class FileSystemNode {
  constructor(name) {
    this.name = name;
    this.repertories = [];
    this.files = [];
  }
}

export default FileSystemNode;



// WEBPACK FOOTER //
// ./src/models/FileSystemNode.js